import { render, staticRenderFns } from "./DefaultImage.vue?vue&type=template&id=43811078&scoped=true&"
import script from "./DefaultImage.vue?vue&type=script&lang=js&"
export * from "./DefaultImage.vue?vue&type=script&lang=js&"
import style0 from "./DefaultImage.vue?vue&type=style&index=0&id=43811078&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43811078",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {AsyncObjectSnippetTooltip: require('/web/components/AsyncObjectSnippetTooltip.vue').default})
